import ContactForm from '../components/ContactForm';
import { Link } from 'react-router-dom';

export default function PrintService() {
  return (
    <div className="min-h-screen bg-gray-50" style={{ background: 'var(--color-bg)', color: 'var(--color-text)' }}>
      <div className="container-custom section">
        <div className="card max-w-2xl mx-auto">
          <h1 className="text-3xl font-bold mb-4 text-accent2">3D Print Service</h1>
          <p className="mb-6 text-lg">
            Wil je jouw eigen 3D-model laten printen? Upload je bestand en ontvang snel een offerte en professioneel geprint resultaat bij jou thuis!
          </p>
          <ol className="mb-6 list-decimal list-inside space-y-2">
            <li>Upload je 3D-bestand (STL, OBJ, etc.)</li>
            <li>Ontvang vrijblijvend een prijsopgave</li>
            <li>Na akkoord wordt je model professioneel geprint</li>
            <li>Snelle en veilige verzending aan huis</li>
          </ol>
          <ContactForm />
        </div>
        <div className="container-custom mt-8 text-center">
          <Link to="/" className="text-accent1 hover:underline">← Terug naar Home</Link>
        </div>
      </div>
    </div>
  );
} 